import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import { QuickGuideReport, Export } from '@/domain/entities/QuickGuideReport'
import router from '@/router'
import Vue from 'vue'
import { QuickGuideReportPresenter } from '@/app/ui/presenters/QuickGuideReportPresenter'
import { AuthModule } from './auth'

export interface QuickGuideState {
  QuickGuideData: QuickGuideReport
  exportData: Export
  isLoading: boolean
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'QuickGuideReport' })
class QuickGuides extends VuexModule implements QuickGuideState {
  public isLoading = true
  public isLoadingExport = true
  public QuickGuideData = new QuickGuideReport(true, '')
  public exportData = new Export(true, '')
  public paginationParam = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
    },
    filter: {
      // salescode: '',
      team: '',
      position: '',
      typeSales: '',
      category: '',
      start: '',
      end: '',
    },
  }
  public paginationParamsExport = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'TotalViews',
      type: 'desc',
    },
    filter: {
      // salescode: '',
      team: '',
      position: '',
      typeSales: '',
      category: '',
      start: '',
      end: '',
    },
  }
  @Action
  public async getQuickGuideData() {
    this.setLoading(true)
    const presenter = await container.resolve(QuickGuideReportPresenter)
    presenter
      .loadQuickGuideReport(this.paginationParam)
      .then((res: QuickGuideReport) => {
        this.setLoading(false)
        this.setQuickGuideData(res)
        //  console.log('Guide Data', res)
      })
      .catch((error) => {
        console.error('error', error)
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
      })
  }
  @Action
  public async getExportData() {
    this.setLoading(true)
    const presenter = await container.resolve(QuickGuideReportPresenter)
    presenter
      .loadExport(this.paginationParam)
      .then((res: Export) => {
        this.setExportData(res)
        //  console.log('export dataaa', res)
      })
      .catch((error) => {
        console.error('error', error)
      })
      .finally(() => {
        this.setLoadingExport(false)
      })
  }

  @Mutation
  private setQuickGuideData(QuickGuide: QuickGuideReport) {
    this.QuickGuideData = QuickGuide
  }
  @Mutation
  private setExportData(exp: Export) {
    this.exportData = exp
  }
  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
  @Mutation
  private setLoadingExport(isLoadingExport: boolean) {
    this.isLoadingExport = isLoadingExport
  }
}

export const QuickGuideReportModule = getModule(QuickGuides)
